import React from 'react';
import { useParams } from 'react-router-dom';
import './App.css';

function HomePlusSuccessPage() {
  const { termId } = useParams();

  return (
    <main className="main-content">
      <div style={{ textAlign: 'center', padding: '50px 20px' }}>
        <h1 style={{ color: '#28a745', marginBottom: '30px' }}>Thank You!</h1>
        <h2>Your HomePlus Terms Acceptance has been submitted successfully</h2>
        <p style={{ fontSize: '18px', marginBottom: '20px' }}>
          Reference: <strong>{termId}</strong>
        </p>
        <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
          We have received your acceptance of the HomePlus Terms of Engagement. 
          Our team will now proceed with your HomePlus survey report.
        </p>
        <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
          You will receive a confirmation email shortly. If you're unsure about anything or wish to cancel, 
          please call us on <span style={{ fontWeight: 'bold', color: '#e91e63' }}>01536 534594</span> quoting your reference: {termId}
        </p>
      </div>
    </main>
  );
}

export default HomePlusSuccessPage;
